import store from 'app/store';

export default function getUserToken(state) {
  const { auth } = state || store.get().getState();
  return auth.get('token');
}
